import { useState, useEffect, useContext } from 'react';
import { AppConfigContext } from '../context';
import { FutarchyProposal } from '../rest/kairos/types';

export const useFutarchyProposals = () => {
    const { apiUrl } = useContext(AppConfigContext);
    const [proposals, setProposals] = useState<FutarchyProposal[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchProposals = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${apiUrl}/kyros/futarchy-proposals`);
            if (!response.ok) {
                // If endpoint doesn't exist yet, return empty array
                if (response.status === 404) {
                    setProposals([]);
                    setIsLoading(false);
                    return;
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            if (data) {
                setProposals(Array.isArray(data) ? data : []);
            }
        } catch (err) {
            console.error("Error fetching futarchy proposals:", err);
            setProposals([]);
            setError("Error fetching proposals");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProposals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { proposals, isLoading, error, refetch: fetchProposals };
};

